<script lang="ts">
  import { onMount } from 'svelte';
  import { Tween } from 'svelte/motion';
  import IconXmark from '$lib/icons/IconXmark.svelte';

  interface Props {
    duration: number;
    onclick?: () => void;
  }

  let { duration, onclick }: Props = $props();

  let tween = $state(new Tween(duration));

  let button = $state<HTMLButtonElement | null>(null);

  onMount(() => {
    tween.set(0, { duration });
  });

  $effect(() => {
    if (tween.current > 0) {
      button?.style.setProperty('--p', ((tween.current / duration) * 100).toString());
    }
  });
</script>

<button
  aria-label="Dismiss"
  type="button"
  bind:this={button}
  class="grid h-[24px] w-[24px] place-items-center text-[10px] tracking-tight"
  {onclick}>
  <span class="scale-75"><IconXmark size="xs"></IconXmark></span>
</button>

<style lang="postcss">
  @reference "tailwindcss";

  button {
    @apply relative;
    --p: 100;
    --b: 2px;
    --bg: white;
    --w: 24px;
  }

  @property --p {
    syntax: '<number>';
    inherits: true;
    initial-value: 0;
  }

  button:before,
  button:after {
    @apply absolute rounded-full content-[''];
  }

  button:before {
    @apply top-0 left-0 scale-x-[-100%] h-full w-full;
    background:
      radial-gradient(farthest-side, var(--bg) 98%, #0000) top/var(--b) var(--b) no-repeat,
      conic-gradient(var(--bg) calc(var(--p) * 1%), rgba(255, 255, 255, 0.1) 0);
    -webkit-mask: radial-gradient(
      farthest-side,
      #000 calc(99% - var(--b)),
      #000 calc(100% - var(--b))
    );
    mask: radial-gradient(farthest-side, #0000 calc(99% - var(--b)), #000 calc(100% - var(--b)));
  }

  button:after {
    inset: calc(50% - var(--b) / 2);
    background: var(--bg);
    transform: rotate(calc((0 - var(--p)) * 3.6deg)) translateY(calc(50% - var(--w) / 2));
  }

  @keyframes p {
    from {
      --p: 100;
    }
    to {
      --p: 0;
    }
  }
</style>
